import './ui.css';

/**
 * 共用空狀態：標題、說明與可選操作。
 */
export default function EmptyState({
  title,
  description,
  action = null,
  icon = null,
  className = '',
  ...rest
}) {
  return (
    <div className={`ui-empty ${className}`.trim()} {...rest}>
      {icon ? <div className="ui-empty__icon" aria-hidden="true">{icon}</div> : null}
      {title ? <h2 className="ui-empty__title">{title}</h2> : null}
      {description ? <p className="ui-empty__description">{description}</p> : null}
      {action ? <div className="ui-empty__action">{action}</div> : null}
    </div>
  );
}
